export var GrantType;
(function (GrantType) {
    GrantType["AuthorizationCode"] = "authorization_code";
    GrantType["RefreshToken"] = "refresh_token";
    GrantType["ClientCredentials"] = "client_credentials";
    GrantType["TokenExchange"] = "urn:ietf:params:oauth:grant-type:token-exchange";
})(GrantType || (GrantType = {}));
